import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative min-h-screen flex flex-col justify-between" }
const _hoisted_2 = { class: "relative z-10 flex flex-1 items-center justify-center p-6" }
const _hoisted_3 = { class: "bg-gray-50 shadow-lg rounded-lg p-8 max-w-md w-full" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_10 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "absolute inset-0 bg-cover bg-center",
        style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/background.png') + ')' })
      }, null, 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-2xl font-semibold text-center mb-6" }, "LOGIN", -1)),
          _createVNode(_component_Form, {
            onSubmit: _ctx.onSubmit,
            "validation-schema": _ctx.schema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-gray-600 text-sm font-semibold mb-2" }, "Mail", -1)),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "mail",
                      placeholder: "Mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-gray-600 text-sm font-semibold mb-2" }, "Contraseña", -1)),
                _createVNode(_component_Field, {
                  name: "password",
                  modelValue: _ctx.formData.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "password",
                      placeholder: "Contraseña",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("button", {
                type: "submit",
                label: "REGISTRARME",
                class: "mt-4 w-full px-4 py-2 bg-black border-black text-white hover:bg-transparent font-semibold hover:text-black border rounded-lg",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[4] || (_cache[4] = _createTextVNode("INGRESAR "))
              ], 8, _hoisted_8),
              _createVNode(_component_BlockUI, {
                blocked: _ctx.isSubmitting,
                fullScreen: ""
              }, null, 8, ["blocked"])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("footer", { class: "w-full py-5 bg-black flex flex-row items-center justify-center text-white font-semibold text-sm" }, [
      _createTextVNode(" © 2025 Desarrollado por "),
      _createElementVNode("a", {
        href: "https://qreventos.com",
        target: "qreventos"
      }, " QREventos")
    ], -1))
  ], 64))
}